import { Injectable } from '@angular/core';
import { BaseApi } from 'app/laas/base-api.service';
import { HttpParams } from '@angular/common/http';


@Injectable()
export class ScaleOfFinanceService {
  constructor(private api: BaseApi) {}

  sofUpdate(userId: string, cropReferenceId: string, updates: any) {
    return this.api.postRes(`/blg/update-sof-amount`, { userId, cropReferenceId, updates });
  }

  getCropList(crop_season: string, type: string, branchCode: string) {
    const params = new HttpParams()
      .set('crop_season', crop_season)
      .set('type', type)
      .set('branch_code', branchCode);

    return this.api.getAll(`/blg/crops-list-sof-update`, { params });
  }

  getCropListByDistrict(userId,district_name){
    return this.api.postRes(`/blg/getcroplist`,{userId,district_name});
    // return of(cropsList);
  }
}
